import React, { useState } from "react";
import { Box, Typography, Divider, Paper } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { Link, useLocation, useNavigate } from "react-router-dom";
import LicenseSection from "./license/LicenseSection";
import {
  fetchApplicationDetails,
  fetchApplicationDetailsRow,
  getTemplateDocumentThunk,
} from "./redux/thunk/application-detailThunk";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { RootState, AppDispatch } from "../../store/store";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { fetchProfile } from "@modules/profile/redux/thunk/profileThunk";

export const ProvisionalPayment: React.FC = () => {
  const location = useLocation();
  const dispatch = useDispatch<AppDispatch>();
  const params = new URLSearchParams(location.search);
  const row = params.get("row");
  const access = params.get("access");
  const [esignCompleted, setEsignCompleted] = useState(false);
  const [applicantdata, setapplicantData] = React.useState<any>(null);
  const [esignTmpURL, setEsignTmpURL] = React.useState<any>(null);
  const { profile } = useSelector((state: RootState) => state.profile);
  const navigate = useNavigate();
  const checkGST = async () => {
    // const profile = await dispatch(fetchProfile()).unwrap();
    if (
      profile?.user_category !== 2 ||
      profile?.organizations?.[0]?.business_name === undefined ||
      profile?.organizations?.[0]?.business_name?.length === 0
    ) {
      toast.error(
        "Please update your profile with valid business details and select category as 'Company/Organization' to Esign.",
      );
      navigate("/view-profile");
    }
  };

  React.useEffect(() => {
    if (row) {
      fetchROW(row);
    } else if (access) {
      fetchAccess(access);
    }
  }, [row, access]);

  React.useEffect(() => {
    if (applicantdata?.application_id) {
      fetchApplicationTempUrl(applicantdata?.application_id);
    }
  }, [applicantdata]);

  const fetchApplicationTempUrl = async (id: any) => {
    try {
      const res = await dispatch(getTemplateDocumentThunk(id)).unwrap();
      checkGST();
      if (res?.data) {
        setEsignCompleted(true);
        setEsignTmpURL(res?.data);
      }
    } catch (error) {
      console.error("Error fetching ROW details:", error);
    }
  };

  const fetchROW = async (id: any) => {
    try {
      const res = await dispatch(fetchApplicationDetailsRow(id)).unwrap();
      setapplicantData(res);
    } catch (error) {
      console.error("Error fetching ROW details:", error);
    }
  };

  const fetchAccess = async (id: any) => {
    try {
      const res = await dispatch(fetchApplicationDetails(id)).unwrap();
      setapplicantData(res);
    } catch (error) {
      console.error("Error fetching ROW details:", error);
    }
  };

  return (
    <Box>
      <div className="page-content">
        {/* <DashboardHeader /> */}
        <Box className="app-details-card">
          <Box className="application-banner">
            <Box>
              {/* Header */}
              <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
                <Link
                  to="/application-dashboard"
                  style={{ textDecoration: "none" }}
                >
                  <ArrowBackIcon sx={{ mr: 1, fontSize: 22, color: "#222" }} />
                </Link>
                <Typography variant="h6" fontWeight={700} sx={{ flex: 1 }}>
                  Provisional NOC E-Signature
                </Typography>
                <Box sx={{ textAlign: "right" }}>
                  <Typography variant="body2" fontWeight={600}>
                    Application No:
                  </Typography>
                  <Typography variant="body2">
                    {applicantdata?.application_code}
                  </Typography>
                </Box>
              </Box>
              <Divider sx={{ mb: 2 }} />
              {/* Main Content */}
              <Box sx={{ display: "flex", gap: 3 }}>
                {/* Left: Bank Guarantee */}
                <Paper
                  sx={{ p: { xs: 1, md: 3 }, borderRadius: 2, width: "100%" }}
                  className="top-wrapper"
                >
                  <Box>
                    <>
                      <Typography
                        sx={{
                          fontFamily: "Inter, sans-serif",
                          fontWeight: 500,
                          fontSize: "15px",
                          color: "#757575",
                          mb: 3,
                          mt: 1,
                        }}
                      >
                        <span style={{ display: "flex", alignItems: "center" }}>
                          <Box
                            component="span"
                            sx={{
                              fontSize: 16,
                              mr: 1,
                              color: "#757575",
                              display: "inline-flex",
                              alignItems: "center",
                              fontWeight: 700,
                            }}
                          >
                            <InfoOutlinedIcon
                              sx={{ fontSize: 20, mr: 1, color: "#757575" }}
                            />
                          </Box>
                          Please carefully review the license document and
                          verify the accuracy of all details provided. The
                          payment has been completed. Final submission of the
                          application is subject to successful e-Signing of the
                          license.
                        </span>
                      </Typography>
                      {/* License Document Preview */}
                      <LicenseSection
                        userData={profile}
                        applicantdata={applicantdata}
                        esignCompleted={esignCompleted}
                        esignTmpURL={esignTmpURL}
                      />
                    </>
                  </Box>
                </Paper>
              </Box>
            </Box>
          </Box>
        </Box>
      </div>
    </Box>
  );
};
